module.exports = __webpack_public_path__ + "img/cashback_low.32c26bf.47b77873.png";